import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    title: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 12,
      fontWeight: 500,
      zIndex: 2,
    },
    item: {
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '15px 10px',
      display: 'flex',
    },
    copyButton: {
      position: 'absolute',
      bottom: 10,
      right: 10,
      background: '#f5f5f5',
      boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
      '&:hover': {
        background: '#e0e0e0',
      },
    },
  });

export const overrideCard = () => {
  const overrideStyles = {
    minHeight: 50,
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  };

  return overrideStyles;
};
